import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Endpoints } from '@/api';
import { useFetch } from '@/utils/fetch';

export const useUpdateEntityOrganization = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch<Endpoints['PATCH /entity-organizations/:id']>();

  return useMutation({
    mutationFn: ({
      id,
      body,
    }: {
      id: string;
      body: Endpoints['PATCH /entity-organizations/:id']['body'];
    }) => fetch(`/entity-organizations/${id}`, undefined, { method: 'PATCH', body }),
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['entities'] });
      await queryClient.invalidateQueries({ queryKey: ['entity-organizations'] });
    },
  });
};
